export default function(fromDate) {
  var now = this.moment(); //now
  fromDate = this.moment(fromDate);
  var days = now.diff(fromDate, "days");
  var hours = now.diff(fromDate, "hours") % 24;
  var minutes = now.diff(fromDate, "minutes") % 60;
  var duration = "Hace " + days + " día/s - " + hours + " hs y " + minutes + " m";
  return duration;
}
